import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import ProfileDialog from "./ProfileDialog"
import { useSelector } from "react-redux";
import { selectGaugeChartKeyDialogVisible, selectNestedPieChartKeyDialogVisible } from "../redux/tooltipsSlice";
import { selectIsShowingProfileDialog, selectIsShowingPopupQuestionDialog } from "../redux/authSlice";
import ChartKeyDialog from "./ChartKeyDialog";
import PopupQuestionDialog from "./PopupQuestionDialog/PopupQuestionDialog";


const Layout = () => {

	const gaugeChartKeyDialogVisible = useSelector(selectGaugeChartKeyDialogVisible);
	const nestedPieChartKeyDialogVisible = useSelector(selectNestedPieChartKeyDialogVisible);
	const profileDialogVisible = useSelector(selectIsShowingProfileDialog);
	const popupQuestionDialogVisible = useSelector(selectIsShowingPopupQuestionDialog);

	return (
		<>
			<Header />
			<main>
				<Outlet />
			</main>
			<Footer />
			{
				(gaugeChartKeyDialogVisible || nestedPieChartKeyDialogVisible) &&
				<ChartKeyDialog chartType={gaugeChartKeyDialogVisible ? "gauge" : "nested pie chart"} />
			}
			{
				profileDialogVisible &&
				<ProfileDialog />
			}
			{
				popupQuestionDialogVisible &&
				<PopupQuestionDialog />
			}
		</>
	)
}

export default Layout